module.exports = __webpack_public_path__ + "static/media/img-st-wallet@2x.48aa7058.png";